import annex6V2Reducers from './reducers';
export { default as annex6V2Actions } from './actions';
export { default as annex6V2Selectors } from './selectors';
export { default as annex6V2Middlewares } from './middlewares';
export {};
export default annex6V2Reducers;
